<style lang="scss">
body {
    background: #f2f2f2;
    height: 100%;
    font-family: "Microsoft YaHei", sans-serif;
}

.dy_notice {
    .flex {
        display: flex;
    }

    background: #f2f2f2;
    .site_banner {
        background: url(../../assets/images/dy/all.png) #51b5c8 no-repeat center
            center;
        height: 300px;
        text-align: center;
        width: auto;
        background-position: 0 -1303px;
        line-height: 300px;
        img {
            vertical-align: middle;
        }
    }
    .content {
        width: 1170px;
        margin: 20px auto;
        margin-bottom: 120px;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 20px 80px 70px 80px;
        background: white;
        border: 1px solid #f5f5f5;
        box-shadow: -3px 0 10px #ebebeb, 3px 0 10px #ebebeb, 0 -3px 10px #ebebeb,
            0 3px 10px #ebebeb;
        .annoucementForm {
            text-align: center;
            font-size: 22px;
            font-weight: 600;
            padding: 10px 0;
        }
    }
    .footer {
        width: 100%;
        position: relative;
        bottom: 0;
        text-align: center;
        border-top: solid 1px #ccc;
        line-height: 80px;
        background: white;
        .containerzz {
            background: url(../../assets/images/dy/all.png);
            height: 58px;
            line-height: 58px;
            width: 400px;
            background-position: 0 -1765px;
            text-align: center;
            margin: 0 auto;
            margin-top: 20px;
        }
    }
}
</style>

<template>
    <div class="dy_notice">
        <div class="site_banner">
            <img src="../../assets/images/dy/logo.png">
        </div>
        <div class="content">
            <div class="annoucementForm-box">
                <div class="annoucementForm">
                    <span class="text">{{noticeInfo.title}}</span>
                </div>
                <div
                    class="detail"
                    v-html="noticeInfo.content"
                >
                </div>
            </div>

        </div>
        <div class="footer">
            <div class="containerzz">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data: function() {
        return {
            noticeInfo: {
                title: "",
                content: ""
            }
        };
    },
    created: function() {
        this.getAnnouncement(this.$route.query.id);
        this.getInfo();
    },
    methods: {
         getkefu: function(id, type) {
            if (type == "live800") {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src =
                    "https://live800.ata-test.net.cn/live800/chatClient/staticButton.js?companyID=228&configID=" +
                    id +
                    "&codeType=steady&delayload=1";
                document.getElementsByTagName("head")[0].appendChild(script);
                var script2 = document.createElement("script");
                script2.type = "text/javascript";
                script2.src =
                    "https://live800.ata-test.net.cn/live800/chatClient/monitor.js?companyID=228&configID=1&codeType=custom&delayload=1";
                document.getElementsByTagName("head")[0].appendChild(script2);
                var script3 = document.createElement("script");
                script3.innerHTML =
                    "function writehtml(){var temptext=StaticIcon_generate();document.getElementById('live81').innerHTML=temptext;setTimeout('write.src',9000);}setTimeout('writehtml()',1500);";
                document.getElementsByTagName("head")[0].appendChild(script3);
            } else {
                let code, link;
                let kefuInfo = id.split("+");
                if (kefuInfo.length > 1) {
                    code = kefuInfo[0].toString();
                    link = kefuInfo[1].toString();
                }
                //udesk
                let udeskScript = document.createElement("script");
                udeskScript.type = "text/javascript";
                udeskScript.innerHTML = `(function(a,h,c,b,f,g){a["UdeskApiObject"]=f;a[f]=a[f]||function(){(a[f].d=a[f].d||[]).push(arguments)};g=h.createElement(c);g.async=1;g.charset="utf-8";g.src=b;c=h.getElementsByTagName(c)[0];c.parentNode.insertBefore(g,c)})(window,document,"script","https://assets-cli.udesk.cn/im_client/js/udeskApi.js","ud");
ud({
    "code": '${code}',
    "link": '${link}',
});
`;
                document
                    .getElementsByTagName("head")[0]
                    .appendChild(udeskScript);
            }
        },
        getInfo: function(domain) {
            this.$http
                .get(globalProvider.serviceUrl("ea/g/pcas/{domain}"), {
                    params: {
                        domain: "zhongxintest"
                    }
                })
                .then(data => {
                    if (data.body.code === resultCode.Success) {
                        if (data.body.data) {
                            if (data.body.data.online_chat) {
                                this.getkefu(
                                    data.body.data.online_chat,
                                    data.body.data.chat_type
                                );
                            }
                        }
                    } else
                        this.$router.push({
                            name: "default.notFound"
                        });
                });
        },
        getAnnouncement(notice_id) {
            this.$http
                .get(globalProvider.serviceUrl("ea/g/nts/d/{notice_id}"), {
                    params: {
                        notice_id: notice_id
                    }
                })
                .then(data => {
                    if (data.body.code == resultCode.Success) {
                        this.noticeInfo = data.body.data;
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(
                            getErrorMessage(data.body.message),
                            "提示",
                            {
                                confirmButtonText: "确定"
                            }
                        );
                    }
                });
        }
    }
};
</script>


